import logo from "./logo.png";
import "./App.css";
import Header from "./components/Header";
import Menu from "./components/Menu";
import Dashboard from "./components/Dashboard";
import Footer from "./components/Footer";
import { Route, Routes, Switch } from "react-router-dom";
import Orders from "./components/orders/Orders";
import Products from "./components/products/Products";
import AddProduct from "./components/products/AddProduct";
import EditProduct from "./components/products/EditProduct";
import OrderDetails from "./components/orders/OrderDetails";
import SingleProduct from "./components/singleProduct/SingleProduct";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Coupons from "./components/coupons/Coupons";
import DropsManager from "./components/drops/DropsManager";
import DropDetails from "./components/drops/DropDetails";
import ContactQueries from "./components/contacts/ContactQueries";
import EnquiryRequests from "./components/enquiries/EnquiryRequests";
import Reviews from "./components/reviews/Reviews";
import { MantineProvider } from '@mantine/core';

function App() {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
    <div class="wrapper">

      <ToastContainer />

      <Header />
      <Menu />
      <Routes>
        <Route element={<Dashboard />} path="/" index exact />
        <Route element={<Orders />} path="/orders" exact />
        <Route element={<OrderDetails />} path="/orders/:id" exact />
        <Route element={<Products />} path="/products" exact />
          <Route element={<AddProduct />} path="/products/add" exact />
          <Route element={<EditProduct />} path="/products/edit/:id" exact />
        <Route element={<SingleProduct />} path="/products/:id" exact />
        <Route element={<Coupons />} path="/coupons" exact />
          <Route element={<DropsManager />} path="/drops" exact />
          <Route element={<DropDetails />} path="/drops/:id" exact />
          <Route element={<ContactQueries />} path="/contacts" exact />
          <Route element={<EnquiryRequests />} path="/enquiries" exact />
          <Route element={<Reviews />} path="/reviews" exact />
      </Routes>

      <Footer />
    </div>
    </MantineProvider>
  );
}

export default App;
